import { post, get } from '@/utils/network';
import { CourseItem } from '@/apis/courseList/courseList';

export interface todoItem {
  // id: string;
  // contentid: string;
  // type_id: string;
  // type_name: string;
  // title: string;
  // groups: string;
  // coursename: string;
  // remind_name: string;
  // detail: string;
  // str_time: string;
  // end_time: string;
  // remind_desc?: string;
  // courseid: string;
  // role: number;
  // other_list: {
  //   no_pay: number;
  //   approved: number;
  //   no_batch: number;
  // };
  contentid: string;
  contenttitle: string | null;
  contenttype: string;
  contenttypename: string;
  courseid: string;
  coursename: string;
  endtime: number;
  id: string;
  link?: Array<{
    name: string;
    type: number;
  }>;
  msgtype: string;
  starttime: string;
  uid: string;
}

export const getHomeTodoList = () => {
  return post<{
    total: number;
    data: Array<todoItem>;
  }>('/todoApi/getIndexList', { limit: 3 });
};

export const getAllTodoList = (id?: string) => {
  return post<{
    contentTotal: string;
    currentPage: number;
    perPageNum: number;
    pageTotal: number;
    content: Array<todoItem>;
  }>('/todoApi/getList', { courseid: id });
};

// 忽略待办事项
export const ignoreTodoItem = ({ classid, contentid, contenttype, msgtype }: { classid: string; contentid: string; contenttype: string; msgtype: string }) => {
  return post('/Futurev2/Todo/ignoreTodo', { classid, contentid, contenttype, msgtype });
};

//标记成已完成
export const tagFinishedTodo = ({ classid, contentid, contenttype, msgtype }: { classid: string; contentid: string; contenttype: string; msgtype: string }) => {
  return post('/Futurev2/Todo/tagFinishedTodo', { classid, contentid, contenttype, msgtype });
};

export const getSysCourseList = () => {
  return post<{
    playground: Array<CourseItem>;
    recommand: Array<CourseItem>;
  }>('/CourseApi/getSysCourseList');
};

export const getTodoList = ({ classid, type, page, limit }: { classid?: string; type?: string | undefined; page?: number | undefined; limit?: number | undefined }) => {
  return post<{
    currentPage: string;
    pageTotal:number,
    pageSize:number,
    listTotal:string,
    list: Array<{
      id: string;
      courseid: string;
      contentid: string;
      contenttype: string;
      starttime: string;
      endtime: string;
      contenttypename: string;
      contenttitle: string;
      coursename: string;
      link: Array<{
        type: number;
        name: string;
      }>;
    }>;
  }>('/Futurev2/Todo/getTodoList', { classid, type, page, limit });
};
export default {
  getHomeTodoList,
  getAllTodoList,
  getSysCourseList
};
